import { render, staticRenderFns } from "./PayNotice.vue?vue&type=template&id=5f7a4132&scoped=true"
import script from "./PayNotice.vue?vue&type=script&lang=js"
export * from "./PayNotice.vue?vue&type=script&lang=js"
import style0 from "./PayNotice.vue?vue&type=style&index=0&id=5f7a4132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7a4132",
  null
  
)

export default component.exports